import React from "react";
import { SimpleLoading, SubtitlePageHLPure, BoxSomeHeadersGLPure, ButtonHLPure, DialogSystemGLPure, PromotionalFooterPure } from "../../pures";
import { Container, Grid } from '@material-ui/core'
import { useTranslation } from "react-i18next"
import ValidateFreelanceDocumentsView from "./validate-freelance-documents.view";
import ValidateFreelanceChatView from "./validate-freelance-chat.view";
import ValidateFreelancePDFView from "./validate-freelance-pdf.view";
import "./validate-freelance.css";
import ValidateFreelanceVarsView from "./validate-freelance-vars.view";

const ValidateFreelanceView = (props) => {
    let {
        toggleCompletedRequesting,
        toggleErrorRequesting,
        toggleLoadingRequesting,
        messageError,
        showLoadingRequesting,
        showCompletedRequesting,
        showErrorRequesting,
        showDocuments,
        showChat,
        showPdf,
        showBtnBackStatus,
        showBtnNextStatus,
        subtitleOne,
        subtitleTwo,
        subtitleThree,
        subtitleFour,
        backBtnName,
        nameBtnNext,
        handleBackBtn,
        titleView,
        callWorkflowProcedureUser,
        isLoadingView,
        cancelBtnName,
        showBtnCancelStatus,
        statusCancel,
        showVars
    } = props

    const { t } = useTranslation()

    
    if(isLoadingView) return <SimpleLoading />
    
    return (
        <div className='validateFreelanceView-container'>
            <Container>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <SubtitlePageHLPure subtitle={titleView} />
                    </Grid>
                    <Grid item xs={12}>
                        <BoxSomeHeadersGLPure
                            titleOne={t("validateFreelanceView.subtitle.one")}
                            subtitleOne={subtitleOne}
                            titleTwo={t("validateFreelanceView.subtitle.two")}
                            subtitleTwo={subtitleTwo}
                            titleThree={t("validateFreelanceView.subtitle.three")}
                            subtitleThree={subtitleThree}
                            titleFour={t("validateFreelanceView.subtitle.four")}
                            subtitleFour={subtitleFour}
                        />
                        <div className="validateFreelanceView-body">
                            <div>
                                {
                                    showDocuments && (
                                        <ValidateFreelanceDocumentsView 
                                            {...props}
                                            t={ t }
                                        />
                                    )
                                } 
                                {
                                    showVars && (
                                        <ValidateFreelanceVarsView 
                                            {...props}
                                            t={ t }
                                        />
                                    )
                                }
                                {
                                    showChat && (
                                        <ValidateFreelanceChatView 
                                            {...props}
                                            t={ t }
                                        />
                                    )
                                }         
                            </div>
                            <div>
                                {
                                    showPdf && (
                                        <ValidateFreelancePDFView
                                            {...props}
                                            t={ t }
                                        />
                                    )
                                }
                            </div>
                        </div>
                        <div className="validateFreelanceView-btns">
                                <div className="validateFreelanceView-btn-back">
                                    <ButtonHLPure
                                        nameBtn={t("button.return")}
                                        primary={false}
                                        onClickBtn={(e) => handleBackBtn(e)}
                                    />
                                </div>
                                {
                                    showBtnBackStatus && (
                                        <div className="validateFreelanceView-btn-back">
                                            <ButtonHLPure
                                                nameBtn={backBtnName}
                                                primary={false}
                                                onClickBtn={(e) => callWorkflowProcedureUser(e, 'back')}
                                            />
                                        </div>
                                    )
                                }
                                {
                                    showBtnCancelStatus && (
                                        <div className="validateFreelanceView-btn-back">
                                            <ButtonHLPure
                                                nameBtn={cancelBtnName}
                                                primary={false}
                                                onClickBtn={(e) => callWorkflowProcedureUser(e, 'defined', statusCancel)}
                                            />
                                        </div>
                                    )
                                }
                                {
                                    showBtnNextStatus && (
                                        <ButtonHLPure
                                            nameBtn={nameBtnNext}
                                            primary={true}
                                            onClickBtn={(e) => callWorkflowProcedureUser(e, 'next')}
                                        />
                                    )
                                }
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <PromotionalFooterPure />
                    </Grid>
                </Grid>
                <DialogSystemGLPure
                    showLoadingRequesting={showLoadingRequesting}
                    showCompletedRequesting={showCompletedRequesting}
                    showErrorRequesting={showErrorRequesting}
                    toggleLoadingRequesting={toggleLoadingRequesting}
                    toggleCompletedRequesting={toggleCompletedRequesting}
                    toggleErrorRequesting={toggleErrorRequesting}
                    message={messageError}
                />
            </Container>
        </div>
    )
}

export { ValidateFreelanceView as default }